import styled, { css } from 'styled-components';

export const ModalWrapper = styled.div`
  ${({ }) => css`
    height: 100%;
  `}
`;

export const SelectWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    margin-bottom: ${theme.spacings[4]};

    .select {
      width: 100%;
      border: 1px solid ${theme.colors.gray900};
      height: 34px;
      font-size: ${theme.font.sizes.md};
      border-radius: 8px;
      appearance: none;
    }

    .sub-select-wrapper {
      display: flex;
      gap: ${theme.spacings[2]};
      margin-top: ${theme.spacings[2]};
    }

    .sub-select {
      width: 100%;
      border: 1px solid ${theme.colors.gray900};
      font-size: ${theme.font.sizes.xs};
      height: 34px;
      border-radius: 8px;
    }

    .MuiSelect-select {
      text-align: center;
      padding-right: 3px !important;
    }
  `}
`;

export const CardWrapper = styled.div`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.gray900};
    border-radius: 8px;
    margin-bottom: ${theme.spacings[4]};
    padding: ${theme.spacings[4]};

    .title {
      font-weight: ${theme.font.weights.bold};
      text-align: center;
      }
      
    .values-wrapper {
      margin-top: ${theme.spacings[4]};
      text-align: center;
    }
  `}
`;

export const ErrorWrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacings[4]};
    font-weight: ${theme.font.weights.bold};
    font-size: ${theme.font.sizes.xl};

    text-align: center;
  `}
`;